// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4fb2ee64","70":"ae03c611","71":"b9ab3f34","195":"89ae1e9d","213":"e09dd4d5","293":"08faf23b","337":"ada0be00","349":"f7a3ed08","360":"65f4e7d6","419":"bd6d4d46","421":"90a3b520","455":"b06a5fc0","606":"d8458ce4","621":"baddb392","870":"4d7d39da","933":"67919134"}[chunkId] + ".chunk.js";
};